export default __webpack_public_path__ + "static/media/palv2homepage.76969574.mp4";